import { Component } from '@angular/core';
import { App } from "ionic-angular";
import { AlertController, ViewController, NavParams, ToastController, ModalController, LoadingController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as moment from 'moment';
import { CalendarComponent, CalendarModal, CalendarComponentOptions } from 'ion2-calendar';
import { Activities, Updates } from 'api/collections';
import { Activity, Update } from 'api/models';
import { AugmentedActivity, ActivityService } from '../../services/activityData';
import { ISDEV, APP_TITLE } from "../../services/config";
import {
  getRemainingDurationInProgressProjectedFinish,
  getPercentCompleteInProgressProjectedFinish,
  daysBetween
} from '../../services/p6calendar';
import { HttpService } from '../../services/httpService';
import { Http } from '@angular/http';

/**
 * Generated class for the ActivityMenuComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'activity-menu',
  templateUrl: 'activity-menu.html'
})
export class ActivityMenuComponent {
  public isDev = ISDEV;
  public disabled = false;
  activity: AugmentedActivity;
  originalActivity: AugmentedActivity;
  day: Date;
  prevActivity: AugmentedActivity | void;
  percentComplete: number;
  remainingDuration: number = 100;
  newRemainingDurationValue: number;
  workDays: any;
  exceptionDays: any;
  newPercentCompleteValue: number;
  newStartDate: string;
  newStartDateValue: Date;
  newFinishDate: string;
  newFinishDateValue: Date;
  projectedFinishDate: Date;
  startDateCalendarOptions: CalendarComponentOptions;
  endDateCalendarOptions: CalendarComponentOptions;
  update: Update;
  ready: boolean;
  hasBeenTouched: boolean;
  showPage: 'actualStart' | 'remainingDuration' | 'percentComplete' | 'actualFinish' | 'prompts' | 'finishToday';
  dismissing = false;
  constructor(
    private _app: App,
    private alertCtrl: AlertController,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public httpService: HttpService,
    private activityService: ActivityService,
  ) {}
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }

  async mainSubscription(activityId, updateId){
 // MeteorObservable.subscribe('activityListForUpdateId', updateId).subscribe();
 this.httpService.MeteorSubscribe('activityListForUpdateId', updateId);
 this.update = Updates.findOne(updateId);
 if(this.isDev == true) {  console.log('looking at update: ', this.update); }
 /*
 const activity: Activity = (
   await MeteorObservable.call("getActivity",
   activityId
 ).toPromise()) as Activity;
 */
 const activity = await this.httpService.MeteorCall('getActivity', activityId);
 console.log('activity:', activity)
 if(this.isDev == true) { console.log('looking at activity: ', activity); }
 this.activity = activity ? this.activityService.getAugmentedActivity(activity) : null;
 this.originalActivity = this.activity;
 // hackiest thing ever, if it can be fixed it should
   for(var i=0; i<50; i++){
     setTimeout(()=>{
       try{
       if(this.hasBeenTouched){
         return;
       }
       if(this.update.updatePeriodType == 'REMAINING_DURATION'){
         this.remainingDuration=this.activity.originalDuration-(this.activity.progressAmount||this.activity.originalDuration);
         this.onChangeRemainingDuration({value:this.remainingDuration})
       } else if(this.update.updatePeriodType == 'PERCENT_COMPLETE'){
         this.percentComplete=this.activity.progressAmount || 0;
         this.onChangePercent({value:this.percentComplete})
       }

       this.ready=true;
     }catch(err){}
     }, i*300)
 }
 let calendarId = this.activity.taskRow.clndr_id;
 this.workDays = this.update.calendars[calendarId].workDays;
 this.exceptionDays = this.update.calendars[calendarId].exceptionDays;
    if(this.isDev == true) { console.log("work days", this.workDays) }
    if(this.isDev == true) { console.log("exception days", this.exceptionDays) }
 if (!this.prevActivity && this.activity) {
   // This is the "first run" so set the initial page
   if (this.isFinishMilestone(this.activity)) {

   }
 }
 if (this.activity) {
   this.startDateCalendarOptions = {
     from: moment().subtract(5, 'years').toDate(),
     to: this.activity.actualFinish ? this.activity.actualFinish : new Date(),
     daysConfig: [{
       date: this.day,
       subTitle: 'Today',
       cssClass: this.activity.actualFinish ? 'actual-finish' : '',
       marked: true,
     }],
   };
   // actualFinish calendar options
   this.endDateCalendarOptions = {
     from: this.activity.actualStart ? new Date(this.activity.actualStart) : moment().subtract(5, 'years').toDate(),
     to: new Date(),
     daysConfig: [{
       date: new Date(),
       subTitle: 'Today',
       cssClass: this.activity.actualFinish ? 'actual-finish' : '',
       marked: true,
     }],
   };

   if (this.activity.actualStart) {
     this.endDateCalendarOptions.daysConfig.push({
       date: this.activity.actualStart,
       subTitle: 'Start',
       cssClass: 'actual-start',
       marked: true,
     });
      this.endDateCalendarOptions.daysConfig.push({
       date: this.activity.actualStart ? new Date(this.activity.actualStart) : this.day,
       subTitle: 'Start',
       cssClass: 'actual-start',
       marked: true,
     });
     this.startDateCalendarOptions.daysConfig.push({
       date: this.activity.actualStart ? new Date(this.activity.actualStart) : this.day,
       subTitle: 'Start',
       cssClass: this.activity.actualStart == new Date() ? 'actual-finish' : 'actual-start',
       marked: true,
     });
     this.startDateCalendarOptions.daysConfig.push({
       date: this.activity.actualStart ? new Date(this.activity.actualStart) : this.day,
       subTitle: 'Start',
       cssClass: this.activity.actualFinish ? 'actual-start' : 'actual-finish',
       marked: true,
     });
   }
    if (this.activity.actualFinish) {
     this.startDateCalendarOptions.daysConfig.push({
       date: this.activity.actualFinish,
       subTitle: 'Finish',
       cssClass: 'actual-finish',
       marked: true,
     });
   }

   const plannedEndDate = this.update && this.update.plannedEndDate;
   const toDate = plannedEndDate && (typeof plannedEndDate === 'string' ? moment(plannedEndDate).toDate() : plannedEndDate);
   // the actualFinish is used above (if it exists). otherwise you can use the plannedEndDate
   if (!this.activity.actualFinish && toDate) {
     this.startDateCalendarOptions.to = new Date();
     this.endDateCalendarOptions.to = new Date();
     this.endDateCalendarOptions.daysConfig.push({
       date: toDate,
       subTitle: 'Planned End',
       marked: true,
     });
   }

 }
 if(this.isDev == true) { console.log('looking at activity: ',this.activity); }
  }

  ngOnInit() {
      this.dismissing = false;

      this.day = new Date();
      this.showPage = 'prompts';
      const activityId = <string>this.navParams.get('activityId');
      const updateId = <string>this.navParams.get('updateId');

      var disabled = false;

      this.httpService.MeteorSubscribe('activityListForUpdateId', updateId);

      this.mainSubscription(activityId, updateId);
    MeteorObservable.autorun().subscribe(async () => {
      this.mainSubscription(activityId, updateId);
     

    });
  }

  getRemainingDurationInProgressProjectedFinish(remainingDuration){
    let activity = {
      ...this.activity,
      progressAmount:remainingDuration
    }
    this.projectedFinishDate=getRemainingDurationInProgressProjectedFinish(this.day, activity, this.workDays, this.exceptionDays)
  }
  getPercentCompleteInProgressProjectedFinish(percentComplete){
    let activity = {
      ...this.activity,
      progressAmount:percentComplete
    }
    this.projectedFinishDate=getPercentCompleteInProgressProjectedFinish(this.day, activity, this.workDays, this.exceptionDays)
  }

  isFinishMilestone(activity) {
    return activity.taskType === 'TT_FinMile';
  }

  isStartMilestone(activity) {
    return activity.taskType === 'TT_Mile';
  }

  async dismissViewCtrl(){
    try{
      if(this.viewCtrl && !this.dismissing){
        this.dismissing=true;
        return this.viewCtrl.dismiss()
      }
    }catch(err){
      if(this.isDev == true) { console.warn(err); }
    }

  }

  goToActualStart(): void {
    this.activity['forceProgressState']='TK_Active';
   this.presentLoading();
    this.showPage = 'actualStart';
  }
  goToActualFinish(): void {
    this.activity['forceProgressState']='TK_Complete';
    this.presentLoading();
    this.showPage = 'actualFinish';
  }
  goToFinishToday(): void {
   this.presentLoading();
    this.showPage = 'finishToday';
  }
  goToPrompts() {
   this.presentLoading();
    this.showPage = 'prompts';
  }
  goToPercentComplete()
 {
    this.presentLoading();
    this.percentComplete = this.activity ? this.activity.percentComplete : 0;
    if(this.activity){
      this.percentComplete = this.activity.progressAmount;
    }
    this.showPage = 'percentComplete';
  }

  goToRemainingDuration() {
   this.presentLoading();
    this.remainingDuration = this.activity ? this.activity.remainingDuration : 0;
    if(this.activity){
      this.remainingDuration = (this.activity.originalDuration - this.activity.progressAmount);
    }
    this.showPage = 'remainingDuration';
  }

  showToast(message: string) {
    let toast = this.toastCtrl.create({
      message,
      duration: 2500,
      position: 'top',
      dismissOnPageChange: true,
    });

    toast.present();
    return toast;
  }

onChangeActualStart(event): void {
  this.updateActualStart(event.toDate());
  if(this.update.updatePeriodType == 'PERCENT_COMPLETE' && this.activity.taskType != 'TT_Mile' && this.activity.taskType != 'TT_FinMile') {
    this.showPage = 'percentComplete';
  } else if(this.activity.taskType == 'TT_Mile' || this.activity.taskType == 'TT_FinMile') {
    return;
  } else {

    this.showPage = 'remainingDuration';

  }

}

 switchDateValue(event): void {
   this.newStartDateValue = event.toDate();

 }

 switchFinishDateValue(event): void {
   this.newFinishDateValue = event.toDate();
 }

 changeActualStart(): void {

   if(!this.newStartDateValue) {
     this.disabled = true;
     return this.updateActualStart(new Date(), true);

   }

   if(this.update.updatePeriodType == 'PERCENT_COMPLETE' && this.activity.taskType != 'TT_Mile' && this.activity.taskType != 'TT_FinMile' && this.activity.actualFinish == null) {
     this.showPage = 'percentComplete';
   } else if(this.update.updatePeriodType == 'REMAINING_DURATION' && this.activity.taskType != 'TT_Mile' && this.activity.taskType != 'TT_FinMile' && this.activity.actualFinish == null) {
     this.showPage = 'remainingDuration';
   } else {
      return this.updateActualStart(this.newStartDateValue, true);
   }

   this.updateActualStart(this.newStartDateValue);
 }

changeActualFinish(showPopup?:boolean, loader?): void {

  if(!this.newFinishDateValue) {
   this.disabled = true;

    return this.updateActualFinish(new Date(), true, showPopup, loader);
  }

  this.disabled = true;
  this.updateActualFinish(this.newFinishDateValue, true, showPopup, loader);
}

  onChangeActualFinish(event): void {
    this.disabled = true;
    this.updateActualFinish(event.toDate());
  }

     onZeroPercent(): void{
      if (!this.activity) {
         if(this.isDev == true) { console.warn('Activity is missing, not updating'); }
        return;
      }
    let newProgressAmount = 0;
    let activityId = this.activity._id;



    const onZeroPercentAlert = this.alertCtrl.create({
      cssClass: 'alert',
      title: 'Clear Progress',
      message: "Are you sure?",
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          if(this.isDev == true) {   console.log('Cancel clicked') }
          }
        },
         {
        text: 'Yes',
        handler: async () => {
          const loader = this.presentLoadingUntimed();
          /*
          await MeteorObservable.call('updateActivityProgress',
            newProgressAmount,
            activityId
          ).toPromise()
          */
          await this.httpService.MeteorCall(
            'updateActivityProgress',
            newProgressAmount,
            activityId
          )
          await loader.dismiss();
          let loader2;
          onZeroPercentAlert.dismiss().then(res=>{
            loader2 = this.presentLoadingUntimed();
            // return MeteorObservable.call('removeActualFinish', activityId).toPromise();
            return this.httpService.MeteorCall('removeActualFinish', activityId);
          })
          .then(res=>{
            // return MeteorObservable.call('removeActualStart', activityId).toPromise()
            return this.httpService.MeteorCall('removeActualStart', activityId);
          })
          .then(async res=>{
            loader2.dismiss();

            this.showToast('Progress Has Been Cleared');
            await this.dismissViewCtrl();
          })
          .catch((e: Error)=>{
            this.handleError(e);
          })
          return false;
        }
      }
      ]
    } as any);
      onZeroPercentAlert.present();
  }



// # percent
  onChangePercent(event): void {
    if(event.id){
      //real touch, cancel setting
      this.hasBeenTouched=true;
    }
    this.newPercentCompleteValue = event.value;
    this.getPercentCompleteInProgressProjectedFinish(this.newPercentCompleteValue)
   if(this.isDev == true) {  console.log('updating percent complete' + this.newPercentCompleteValue) }
  }

  submitPercentComplete(): void{
    this.disabled = true;
    this.updatePercentComplete();
  }

  donePercentComplete() {
    this.disabled = true;
    this.updatePercentComplete();
  }

finishedToday(event): void {
  let dismiss = false;
  if(this.update.updatePeriodType == 'PERCENT_COMPLETE' && this.activity.taskType != 'TT_Mile' && this.activity.taskType != 'TT_FinMile') {
    dismiss = true;
  } else if(this.update.updatePeriodType == 'REMAINING_DURATION' && this.activity.taskType != 'TT_Mile' && this.activity.taskType != 'TT_FinMile') {
    dismiss = true;
  } else {
    dismiss = true;
  }
  this.updateFinishToday(moment().toDate(), dismiss);

}
startedToday(event): void {
  this.activity['forceProgressState']='TK_Active';
  this.activity['forceStartDate'] = moment().toDate()
  let dismiss = false;
  if(this.update.updatePeriodType == 'PERCENT_COMPLETE' && this.activity.taskType != 'TT_Mile' && this.activity.taskType != 'TT_FinMile') {
    this.showPage = 'percentComplete';
  } else if(this.update.updatePeriodType == 'REMAINING_DURATION' && this.activity.taskType != 'TT_Mile' && this.activity.taskType != 'TT_FinMile') {
    this.showPage = 'remainingDuration';
  } else {
    dismiss=true;
  }
    this.newRemainingDurationValue = 0;
  this.getRemainingDurationInProgressProjectedFinish(this.activity.originalDuration - this.newRemainingDurationValue);
  // this.updateRemainingDuration();
  this.updateActualStart(moment().toDate(), dismiss);

}

  onChangeRemainingDuration(event): void {
   if(event){
    //real touch, cancel setting
    this.hasBeenTouched=true;
    this.newRemainingDurationValue = event.value;
  }

    if(this.update.updatePeriodType == 'REMAINING_DURATION'){
     this.newRemainingDurationValue = event.value;
    this.getRemainingDurationInProgressProjectedFinish(this.activity.originalDuration - this.newRemainingDurationValue);
    } else if(this.update.updatePeriodType == 'PERCENT_COMPLETE'){
     this.newPercentCompleteValue = event.value;
     this.getRemainingDurationInProgressProjectedFinish(this.newPercentCompleteValue);
    }
   if(this.isDev == true) {  console.log('looking at remaining duration change', event.value); }
    }

 submitRemainingDuration(): void {
   this.updateRemainingDuration();
 }

    onChangePercentComplete(event): void {
     this.newPercentCompleteValue = event.value;
      this.getRemainingDurationInProgressProjectedFinish(this.newPercentCompleteValue)
     if(this.isDev == true) { console.log('looking at Percent Complete change', event.value); }

    }

 doneRemainingDuration() {
   this.updateRemainingDuration();

 }

// user calendar start
  updateActualStart(newActualStart: Date, dismiss?: boolean): void {
  if(!this.activity) {
     if(this.isDev == true) { console.warn('Activity is missing, not updating'); }
    return;
  }

  const activityId = this.activity._id;

  /*
  MeteorObservable.call('updateActualStart',
    activityId,
    newActualStart,
  ).subscribe({
    next: async () => {
      this.showToast('Actual Start date saved');
      this.activity.actualStart=newActualStart;
      this.activity['forceStartDate']=newActualStart;
      if(dismiss){
        await this.dismissViewCtrl();
      }
    },
    error: (e: Error) => {
      this.handleError(e);
    }
  });
  */

  this.httpService.MeteorCall(
    'updateActualStart',
    activityId,
    newActualStart
  ).then(async () => {
    this.showToast('Actual Start date saved');
    this.activity.actualStart=newActualStart;
    this.activity['forceStartDate']=newActualStart;
    if(dismiss){
      await this.dismissViewCtrl();
    }
  })
  .catch((e: Error) => {
    this.handleError(e);
  });
}
removeActualStart(): void {
  if(!this.activity) {
   if(this.isDev == true) {   console.warn('Activity is missing, not updating'); }
    return;
  }
  let activityId = this.activity._id;

  const alert = this.alertCtrl.create({
    cssClass: 'alert',
    title: 'Remove Start',
    message: `Are you sure?`,
    buttons: [{
        text: 'Cancel',
        role: 'cancel',
      },
      {
        text: 'Yes',
        handler: () => {
          /*
          MeteorObservable.call('removeActualStart', activityId).subscribe({
            error: (e: Error) => {
              if(e) {
                this.handleError(e);
              }
            }
          });
          */
          this.httpService.MeteorCall('removeActualStart', activityId)
            .then(() => {
              // console.log('')
            })
            .catch((e: Error) => {
              if(e) {
                this.handleError(e);
              }
            });
          alert.dismiss().then(async () => {
            if(this.update.updatePeriodType == 'PERCENT_COMPLETE' && this.activity.taskType != 'TT_Mile' && this.activity.taskType != 'TT_FinMile') {
              this.goToPrompts();
            } else if(this.activity.taskType == 'TT_Mile' || this.activity.taskType == 'TT_FinMile') {
              await this.dismissViewCtrl();
            } else {
              this.goToPrompts();
            }

          });
          return false;
        }
      }
    ]
  });
  alert.present();
}

// update calendar finish
  updateActualFinish(newActualFinish: Date, dismiss?: boolean, showPopup?:boolean, loader?): void {
    if(!this.activity) {
      if(this.isDev == true) {  console.warn('Activity is missing, not updating'); }
      return;
    }
    let activityId = this.activity._id;

    // get days between
    let duration = 0;
    if(this.update.updatePeriodType == 'PERCENT_COMPLETE'){
      duration=100;
    }
    daysBetween(this.activity.actualStart,newActualFinish, this.workDays, this.exceptionDays)
    /*
    MeteorObservable.call(
      'updateActivityProgress',
      duration,
      activityId
    ).subscribe({
      next: () => {
        MeteorObservable.call('updateActualFinish',
        activityId,
        newActualFinish
      ).subscribe({
        next: async () => {
          if(loader){
            await loader.dismiss();
          }

          if(dismiss){
            await this.dismissViewCtrl();
            if(showPopup){
              this.showActivityProgressedToCompletionModal()
            }
          }
          this.showToast('Actual Finish date saved');
        }
      });
      },
      error: (e: Error) => {
        this.handleError(e);
      }
    });
    */

    this.httpService.MeteorCall(
      'updateActivityProgress',
      duration,
      activityId
    ).then(() => {
      this.httpService.MeteorCall(
        'updateActualFinish',
        activityId,
        newActualFinish
      ).then(async () => {
      if(loader){
        await loader.dismiss();
      }
      if(dismiss){
        await this.dismissViewCtrl();
        if(showPopup){
          this.showActivityProgressedToCompletionModal()
        }
      }
      this.showToast('Actual Finish date saved');
    })
    .catch((e: Error) => {
      this.handleError(e);
    })
  })
  .catch((e: Error) => {
    this.handleError(e);
  })
}

updateFinishToday(newActualFinish: Date, dismiss?: boolean): void {
  this.updateActualFinish(newActualFinish, dismiss);
}

removeActualFinish(): void {
  if(!this.activity) {
   if(this.isDev == true) {   console.warn('Activity is missing, not updating'); }
    return;
  }
  let activityId = this.activity._id;

  const alert = this.alertCtrl.create({
    cssClass: 'alert',
    title: 'Remove Finish',
    message: `Are you sure?`,
    buttons: [{
        text: 'Cancel',
        role: 'cancel',
      },
      {
        text: 'Yes',
        handler: () => {
          this.activity['forceProgressState']="TK_Active";
          /*
          MeteorObservable.call('removeActualFinish', activityId).subscribe({
            error: (e: Error) => {
              if(e) {
                this.handleError(e);
              }
            }
          });
          */
          this.httpService.MeteorCall('removeActualFinish', activityId)
            .then(() => {})
            .catch((e: Error) => {
              if(e) {
                this.handleError(e);
              }
            });
          alert.dismiss().then(async () => {
            this.activity.actualFinish=undefined;

            if(this.update.updatePeriodType == 'PERCENT_COMPLETE' && this.activity.taskType != 'TT_Mile' && this.activity.taskType != 'TT_FinMile') {
              this.showPage = 'percentComplete';
            } else if(this.activity.taskType == 'TT_Mile' || this.activity.taskType == 'TT_FinMile') {
              await this.dismissViewCtrl();
            } else {

              this.showPage = 'remainingDuration';
            }
          });
          return false;


        }
      }
    ]
  });

  alert.present();
}

updatePercentComplete(): void {
  const loader = this.presentLoadingUntimed();

  this.disabled = true;

  if(!this.newPercentCompleteValue) {
    this.newPercentCompleteValue = 0;
  }

  if(!this.activity) {
    if(this.isDev == true) {  console.warn('Activity is missing, not updating'); }
    return;
  }

  let activityId = this.activity._id;
  let newProgressAmount = this.newPercentCompleteValue;

  /*
  MeteorObservable.call('updateActivityProgress',
    newProgressAmount,
    activityId
  ).subscribe({
    next: async () => {
      if(newProgressAmount >= 95) {
        await this.updateActualFinish(new Date());
        await this.changeActualFinish(true, loader)
        if(this.isDev == true) {  console.log('Percent Value == 99 ', newProgressAmount); }
        this.disabled = false;
      } else {
        await loader.dismiss();
        await this.dismissViewCtrl();
        if(this.isDev == true) {  console.log('Percent Value != 99 ', newProgressAmount); }
        this.disabled = false;
      }
      this.showToast('Percent change saved');
      if(this.isDev == true) {  console.log('Percent Value = ', newProgressAmount); }
      this.disabled = false;
    },
    error: async (e: Error) => {
      await loader.dismiss()
      this.handleError(e);
    }
  });
  */

  this.httpService.MeteorCall(
    'updateActivityProgress',
    newProgressAmount,
    activityId
  ).then(async () => {
    if(newProgressAmount >= 95) {
      await this.updateActualFinish(new Date());
      await this.changeActualFinish(true, loader)
      if(this.isDev == true) {  console.log('Percent Value == 99 ', newProgressAmount); }
      this.disabled = false;
    } else {
      await loader.dismiss();
      await this.dismissViewCtrl();
      if(this.isDev == true) {  console.log('Percent Value != 99 ', newProgressAmount); }
      this.disabled = false;
    }
    this.showToast('Percent change saved');
    if(this.isDev == true) {  console.log('Percent Value = ', newProgressAmount); }
    this.disabled = false;
  })
  .catch(async (e: Error) => {
    await loader.dismiss()
    this.handleError(e);
  });
}


updateRemainingDuration(): void {
  const loader = this.presentLoadingUntimed();
  this.disabled = true;
  let newProgressAmount = this.activity.originalDuration-this.newRemainingDurationValue;
  if(!this.activity) {
    if(this.isDev == true) {  console.warn('Activity is missing, not updating'); }
    return;
  }
  let activityId = this.activity._id;

  /*
  MeteorObservable.call('updateActivityProgress',
    newProgressAmount,
    activityId
  ).subscribe({
    next: async () => {
      if(newProgressAmount == 0) {
        await this.updateActualFinish(new Date());
        await this.changeActualFinish(true, loader)
        if(this.isDev == true) {  console.log('RD Value == 0 ', newProgressAmount); }
      } else {
        await loader.dismiss()
        await this.dismissViewCtrl();
        if(this.isDev == true) {   console.log('RD Value != 0 ', newProgressAmount); }
      }
      this.showToast('Remaining Duration Saved');
      this.disabled = false;
    },
    error: async (e: Error) => {
      await loader.dismiss();
      this.handleError(e);
    }
  });
  */

  this.httpService.MeteorCall(
    'updateActivityProgress',
    newProgressAmount,
    activityId
  ).then(async () => {
    if(newProgressAmount == 0) {
      await this.updateActualFinish(new Date());
      await this.changeActualFinish(true, loader)
      if(this.isDev == true) {  console.log('RD Value == 0 ', newProgressAmount); }
    } else {
      await loader.dismiss()
      await this.dismissViewCtrl();
      if(this.isDev == true) {   console.log('RD Value != 0 ', newProgressAmount); }
    }
    this.showToast('Remaining Duration Saved');
    this.disabled = false;
  })
  .catch(async (e: Error) => {
    await loader.dismiss();
    this.handleError(e);
  });
}

removeActivityStart(): void {
this.presentLoading();
this.disabled = true;

  if(!this.activity) {
    if(this.isDev == true) {  console.warn('Activity is missing, not updating'); }
    return;
  }
  let activityId = this.activity._id;
  /*
  MeteorObservable.call('removeActualStart', activityId).subscribe({
    error: (e: Error) => {
      if(e) {
        this.handleError(e);
      }
    }
  });
  */

  this.httpService.MeteorCall('removeActualStart', activityId)
    .then(() => {})
    .catch((e: Error) => {
      this.handleError(e);
    });
  this.disabled = false;

}
removeActivityFinish(): void {
this.presentLoading();
this.disabled = true;
  if(!this.activity) {
   if(this.isDev == true) {   console.warn('Activity is missing, not updating'); }
    return;
  }
  let activityId = this.activity._id;

  /*
  MeteorObservable.call('removeActualFinish', activityId).subscribe({
    error: (e: Error) => {
      if(e) {
        this.handleError(e);
      }
    }
  });
  */

  this.httpService.MeteorCall('removeActualFinish', activityId)
    .then(() => {})
    .catch((e: Error) => {
      if (e) {
        this.handleError(e);
      }
    })
  this.disabled = false;
}

removeRemainingDuration(): void {
this.presentLoading()
this.disabled = true;
  if(!this.newRemainingDurationValue) {
    return;
  }

  if(!this.activity) {
    if(this.isDev == true) {  console.warn('Activity is missing, not updating'); }
    return;
  }

  this.newPercentCompleteValue = 0;
  let activityId = this.activity._id;
  let newProgressAmount = this.newPercentCompleteValue;

 setTimeout(() => {
  /*
  MeteorObservable.call('updateActivityProgress',
    newProgressAmount,
    activityId
  ).subscribe({
    error: (e: Error) => {
      if(e) {
        this.handleError(e);
      }
    }
  });
  */

  this.httpService.MeteorCall(
    'updateActivityProgress',
    newProgressAmount,
    activityId
  ).then(() => {})
  .catch((e: Error) => {
    if (e) {
      this.handleError(e);
    }
  });

  this.disabled = false;
  }, 500);
}

showActivityProgressedToCompletionModal(){
  const alert = this.alertCtrl.create({
    cssClass: 'alert',
    buttons: ['OK'],
    message: "Today's date was assigned as the finish date",
    title: 'Task Completed'
  });
  alert.present();
}

presentLoading() {
    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      duration: 500,
      enableBackdropDismiss: true,
    });
    loader.present();
  }

  presentLoadingUntimed() {
    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      enableBackdropDismiss: true,
    });
    loader.present();
    return loader;
  }

onChange(ev: any) {
 if(this.isDev == true) {   console.log('Changed', ev); }
}

handleError(e: Error): void {
 if(this.isDev == true) {   console.error(e); }
  const alert = this.alertCtrl.create({
    cssClass: 'alert',
    buttons: ['OK'],
    message: e.message,
    title: 'Oops!'
  });
  alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/activity-menu/activity-menu.ts